import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { FullPageState } from '../components/States'

export function ProtectedRoute() {
  const { session, loading } = useAuth()
  const location = useLocation()
  if (loading) return <FullPageState title="正在加载商户资料" />
  if (!session) return <Navigate to="/login" replace state={{ from: location.pathname }} />
  if (session.recoveryMode && location.pathname !== '/settings') return <Navigate to="/settings" replace />
  return <Outlet />
}
